/*
 * PACK SUMMER — module partagé (v3)
 * ---------------------------------------------------------------------------
 * Chargé par les pages du parcours : intro, compose, fiche produit, panier,
 * récap. Chaque page appelle UNE fonction d'initialisation ; le module ne
 * lance rien tout seul.
 *
 * Règles du parcours :
 *  1. On n'entre dans le parcours QUE par un clic explicite (bouton
 *     « Composer mon pack », ou une action du récap).
 *  2. Le panier ne fait avancer le parcours QUE pour le produit « armé » :
 *     celui que le client a choisi depuis une étape (ou via Modifier,
 *     Changer, sac). Un produit ajouté par ailleurs — même s'il appartient
 *     aux collections du pack, qui sont aussi vendues à l'unité — ne
 *     déclenche ni bannière ni redirection.
 *  3. Les PRIX affichés reflètent le panier entier, comme la fonction de
 *     remise au checkout : ce qui est affiché = ce qui est payé.
 *  4. Plusieurs modèles par étape sont permis et s'additionnent.
 *  5. La vraie quantité Kickflip est la propriété « Quantité », imbriquée
 *     dans properties._mczr_attributes, PAR unité native.
 */
(function () {
  'use strict';
  if (window.PackSummer && window.PackSummer.__v === 3) return;

  /* ======================================================================
     Constantes
     ====================================================================== */
  var KEY = 'packSummerState';
  var MAX_IDLE_MS = 6 * 60 * 60 * 1000;   /* parcours oublié après 6 h sans activité */
  var ARM_TTL_MS = 2 * 60 * 60 * 1000;    /* un produit armé le reste 2 h */
  var COLLECTIONS = [
    'pack-summer-la-base',
    'pack-summer-ingredients',
    'pack-summer-proteine',
    'pack-summer-sauce'
  ];
  var STEPS = [
    { name: 'La Base', hint: 'Le haut', choose: 'Choisis ton haut' },
    { name: 'Les Ingrédients', hint: 'Le bas', choose: 'Choisis ton bas' },
    { name: 'La Protéine', hint: 'Le dessous', choose: 'Choisis ton dessous' },
    { name: 'La Sauce', hint: "L'accessoire", choose: 'Choisis ton accessoire' }
  ];
  var SAC = 'sac-a-dos-personnalise';
  var URLS = {
    intro: '/pages/introduction-au-pack-summer',
    compose: '/pages/personnalisez-votre-pack-summer',
    summary: '/pages/finalisation-pack-summer',
    sac: '/products/sac-a-dos-personnalise',
    checkout: '/checkout'
  };
  var PACK_PRICE_SMALL = 11000;  /* centimes, 1 à 9 packs */
  var PACK_PRICE_BULK = 8000;    /* centimes, dès 10 packs */
  var BULK_THRESHOLD = 10;
  var SAC_PACK_PRICE = 2000;     /* centimes, 1 sac par pack complet */

  var isEditor = false;
  try {
    isEditor = !!(window.Shopify && window.Shopify.designMode) ||
      /\/editor|design_theme_id/.test(location.href) ||
      window.self !== window.top;
  } catch (e) { isEditor = true; }

  function now() { return Date.now(); }

  /* ======================================================================
     État
     ====================================================================== */
  function read() {
    try { var r = localStorage.getItem(KEY); return r ? JSON.parse(r) : null; } catch (e) { return null; }
  }
  function write(s) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
    return s;
  }
  function blank(active) {
    return {
      v: 3, active: !!active, startedAt: now(), lastActivityAt: now(),
      currentStep: 0, armed: null, seenKeys: [], replacing: null,
      pendingMode: null, sacChoice: null,
      /* champs hérités, lus par d'anciennes copies de script */
      steps: [null, null, null, null], lineItemKeys: [null, null, null, null],
      editingStep: null, changingStep: null
    };
  }
  /* État du parcours s'il est en cours, sinon null. Ne crée jamais rien. */
  function getActive() {
    var s = read();
    if (!s || s.active !== true) return null;
    var last = s.lastActivityAt || s.startedAt || 0;
    if (now() - last > MAX_IDLE_MS) { s.active = false; s.armed = null; write(s); return null; }
    return s;
  }
  /* État actif, créé si besoin — UNIQUEMENT depuis une action explicite. */
  function ensureActive() {
    var s = getActive();
    if (s) return s;
    var prev = read();
    s = blank(true);
    if (prev && prev.sacChoice) s.sacChoice = prev.sacChoice;
    return s;
  }
  function touch(s) { s.lastActivityAt = now(); return write(s); }
  function armedFor(s, handle) {
    if (!s || !s.armed) return null;
    if (now() - (s.armed.at || 0) > ARM_TTL_MS) return null;
    if (handle && s.armed.handle !== handle) return null;
    return s.armed;
  }
  function exitPack() {
    var s = read();
    if (s) { s.active = false; s.armed = null; s.pendingMode = null; s.replacing = null; write(s); }
  }

  /* ======================================================================
     Panier & collections
     ====================================================================== */
  var nativeFetch = window.fetch.bind(window);

  function getCart() {
    return nativeFetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(enrichCart);
  }
  /* Modifier une ligne par son identité stable : la clé est relue dans le
     panier juste avant, car chaque modification renumérote les autres lignes. */
  function changeById(id, quantity) {
    return nativeFetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var it = (c.items || []).filter(function (i) { return lineId(i) === id; })[0];
        if (!it) return null;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: quantity })
        });
      });
  }
  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  var collectionsPromise = null;
  function loadCollections() {
    if (collectionsPromise) return collectionsPromise;
    try {
      var cached = JSON.parse(sessionStorage.getItem('packSummerCollections') || 'null');
      if (cached && now() - cached.at < 10 * 60 * 1000 && cached.data && cached.data.length === 4) {
        collectionsPromise = Promise.resolve(cached.data);
        return collectionsPromise;
      }
    } catch (e) {}
    collectionsPromise = Promise.all(COLLECTIONS.map(function (h) {
      return nativeFetch('/collections/' + h + '/products.json?limit=250')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return (d.products || []).map(function (p) { return p.handle; }); })
        .catch(function () { return []; });
    })).then(function (data) {
      try { sessionStorage.setItem('packSummerCollections', JSON.stringify({ at: now(), data: data })); } catch (e) {}
      return data;
    });
    return collectionsPromise;
  }
  function stepOf(cols, handle) {
    if (handle === SAC) return 'sac';
    for (var i = 0; i < 4; i++) { if (cols[i] && cols[i].indexOf(handle) !== -1) return i; }
    return -1;
  }

  /* Vraie quantité Kickflip d'une ligne (voir règle 5). */
  /* Certains configurateurs (casquette brodée) ont une question quantité dont
     le titre est vide dans Kickflip. Kickflip écarte les réponses sans titre en
     écrivant le panier : la quantité n'existe alors QUE dans le design. On la
     relit via le proxy /apps/kickflip (celui qu'utilise Kickflip à l'ajout).
     Un design Kickflip ne change jamais (« Modifier » en crée un nouveau) :
     le cache par designId est sûr. */
  var DESIGN_QTY_KEY = 'packSummerDesignQty';
  var designQty = {};
  try { designQty = JSON.parse(localStorage.getItem(DESIGN_QTY_KEY) || '{}') || {}; } catch (e) {}
  function isQtyKey(k) { k = String(k || '').trim().toLowerCase(); return k === 'quantité' || k === 'quantite' || k === 'quantity'; }
  function designQuantity(id) {
    if (designQty[id]) return Promise.resolve(designQty[id]);
    return nativeFetch('/apps/kickflip/designs/' + encodeURIComponent(id) + '/cart-properties?brand=297af4-4', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var entries = (d && d.summary_v2) || [];
        var q = 0;
        for (var i = 0; i < entries.length && !q; i++) {
          var k = String(entries[i].key || '').trim();
          var v = String(entries[i].value == null ? '' : entries[i].value).trim();
          if ((k === '' || isQtyKey(k)) && /^\d+$/.test(v)) q = parseInt(v, 10);
        }
        if (q > 0) {
          designQty[id] = q;
          try { localStorage.setItem(DESIGN_QTY_KEY, JSON.stringify(designQty)); } catch (e) {}
        }
        return q;
      })
      .catch(function () { return 0; });
  }
  function enrichCart(cart) {
    var items = (cart && cart.items) || [];
    return Promise.all(items.map(function (it) {
      var id = it.properties && it.properties._mczr_designId;
      if (!id || explicitQty(it)) return null;
      return designQuantity(id).then(function (q) { if (q > 0) it.__psQty = q; });
    })).then(function () { syncDesignQtyAttribute(cart); return cart; });
  }
  /* La remise du checkout (fonction Shopify) ne peut pas interroger Kickflip.
     On lui recopie donc ces quantités dans un attribut de panier caché
     (préfixe _), qu'elle lit quand une ligne n'a pas de « Quantité ».
     L'attribut suit aussi la commande : la production y retrouve le nombre. */
  var DESIGN_QTY_ATTR = '_ps_design_qty';
  var syncingAttr = false;
  function syncDesignQtyAttribute(cart) {
    if (syncingAttr || !cart || !cart.items) return;
    var want = {};
    cart.items.forEach(function (it) {
      var id = it.properties && it.properties._mczr_designId;
      if (id && it.__psQty) want[id] = it.__psQty;
    });
    var have = {};
    try { have = JSON.parse((cart.attributes && cart.attributes[DESIGN_QTY_ATTR]) || '{}') || {}; } catch (e) {}
    var ids = Object.keys(want);
    var stale = ids.some(function (id) { return have[id] !== want[id]; });
    if (!stale) return;
    var merged = {};
    /* on ne garde que les designs encore au panier */
    ids.forEach(function (id) { merged[id] = want[id]; });
    syncingAttr = true;
    var body = { attributes: {} };
    body.attributes[DESIGN_QTY_ATTR] = JSON.stringify(merged);
    nativeFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function () {
      syncingAttr = false;
      /* la remise vient d'être recalculée : les pages ouvertes se redessinent */
      try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
      notifyCartChange();
    }, function () { syncingAttr = false; });
  }

  function lineQty(item) {
    var nativeQty = (item && item.quantity) || 1;
    return explicitQty(item) || ((item && item.__psQty) ? item.__psQty * nativeQty : nativeQty);
  }
  function explicitQty(item) {
    var nativeQty = (item && item.quantity) || 1;
    var props = (item && item.properties) || {};
    var raw = props._mczr_attributes;
    if (raw) {
      try {
        var attrs = JSON.parse(raw);
        if (Array.isArray(attrs)) {
          for (var a = 0; a < attrs.length; a++) {
            var k = String((attrs[a] && attrs[a].key) || '').trim().toLowerCase();
            if (k === 'quantité' || k === 'quantite' || k === 'quantity') {
              var q = parseInt(attrs[a].value, 10);
              if (!isNaN(q) && q > 0) return q * nativeQty;
            }
          }
        }
      } catch (e) {}
    }
    var keys = Object.keys(props);
    for (var i = 0; i < keys.length; i++) {
      var kk = keys[i].trim();
      if (kk === 'Quantité' || kk === 'Quantity') {
        var p = parseInt(props[keys[i]], 10);
        if (!isNaN(p) && p > 0) return p * nativeQty;
      }
    }
    return 0;
  }

  /* Identité STABLE d'une ligne. La clé Shopify (item.key) change dès que la
     remise du panier est recalculée : ajouter une ligne renumérote les autres.
     Mesuré le 16/09/2026 — la casquette à remplacer avait changé de clé entre
     « Modifier » et le retour au panier, rien n'était retiré. Un design Kickflip
     est unique : son _mczr_designId identifie la ligne quoi qu'il arrive. */
  function lineId(item) {
    if (!item) return '';
    /* Pas le designId seul : rajouter le même design crée une 2e ligne (jeton
       Kickflip différent) avec le même designId. L'empreinte des propriétés
       est propre à chaque ligne et ne bouge pas quand la remise change. */
    var props = item.properties || {};
    var names = Object.keys(props).sort();
    var str = String(item.variant_id || item.id || '') + '|' + names.map(function (n) { return n + '=' + props[n]; }).join('|');
    var h = 5381;
    for (var i = 0; i < str.length; i++) h = ((h * 33) ^ str.charCodeAt(i)) >>> 0;
    var d = props._mczr_designId;
    return (d ? 'd:' + d : 'v:' + (item.variant_id || '')) + ':' + h.toString(36);
  }

  /* Analyse du panier, calquée sur la fonction de remise au checkout. */
  function analyse(cart, cols) {
    var slots = [[], [], [], []], sac = [], out = [];
    (cart.items || []).forEach(function (item) {
      var st = stepOf(cols, item.handle);
      var qty = lineQty(item);
      var orig = item.original_line_price != null ? item.original_line_price : (item.line_price || 0);
      var fin = item.final_line_price != null ? item.final_line_price : (item.line_price || 0);
      var line = { item: item, qty: qty, orig: orig, final: fin, unit: qty > 0 ? orig / qty : orig };
      if (st === 'sac') sac.push(line);
      else if (st === -1) out.push(line);
      else slots[st].push(line);
    });

    var qtyBy = slots.map(function (ls) { return ls.reduce(function (s, l) { return s + l.qty; }, 0); });
    var filled = qtyBy.map(function (q) { return q > 0; });
    var packs = filled.every(Boolean) ? Math.min.apply(null, qtyBy) : 0;

    /* unités hors pack : on consomme `packs` unités par étape, petites lignes d'abord */
    var extras = [], extrasTotal = 0;
    slots.forEach(function (ls, i) {
      var remaining = packs;
      ls.slice().sort(function (a, b) { return a.qty - b.qty; }).forEach(function (l) {
        var consumed = Math.min(l.qty, Math.max(remaining, 0));
        remaining -= consumed;
        var extra = l.qty - consumed;
        if (extra > 0) {
          var value = Math.round(l.unit * extra);
          extras.push({ step: i, title: l.item.product_title, qty: extra, value: value });
          extrasTotal += value;
        }
      });
    });

    var packUnit = packs >= BULK_THRESHOLD ? PACK_PRICE_BULK : PACK_PRICE_SMALL;
    var packTotal = packs * packUnit;
    var sacQty = sac.reduce(function (s, l) { return s + l.qty; }, 0);
    var sacTotal = sac.reduce(function (s, l) { return s + l.final; }, 0);
    var packLines = slots.reduce(function (a, ls) { return a.concat(ls); }, []).concat(sac);
    var grandTotal = packLines.reduce(function (s, l) { return s + l.final; }, 0);
    var grandOrig = packLines.reduce(function (s, l) { return s + l.orig; }, 0);

    return {
      slots: slots, sac: sac, others: out, qtyBy: qtyBy, filled: filled, packs: packs,
      packUnit: packUnit, packTotal: packTotal, extras: extras, extrasTotal: extrasTotal,
      sacQty: sacQty, sacInPack: Math.min(sacQty, packs), sacTotal: sacTotal,
      grandTotal: grandTotal, grandOrig: grandOrig, hasPackLines: packLines.length > 0,
      keys: (cart.items || []).map(lineId),
      qtys: (cart.items || []).reduce(function (m, i) { m[lineId(i)] = i.quantity; return m; }, {})
    };
  }

  /* Remplacement après Modifier / Changer : retirer l'ancienne ligne SEULEMENT
     si une ligne absente de la photo prise au départ est arrivée dans l'étape.
     Rend true si une suppression a eu lieu. */
  function reconcileReplacement(s, cart, cols) {
    var rep = s && s.replacing;
    var oldKeys = rep ? (Array.isArray(rep.keys) && rep.keys.length ? rep.keys : (rep.key ? [rep.key] : [])) : [];
    if (!oldKeys.length) return Promise.resolve(false);
    var present = [], newArrived = false;
    (cart.items || []).forEach(function (it) {
      var id = lineId(it);
      /* on retire par la clé ACTUELLE, lue dans ce panier-ci */
      if (oldKeys.indexOf(id) !== -1) { present.push(id); return; }
      if (stepOf(cols, it.handle) !== rep.step) return;
      if (Array.isArray(rep.snapshot) && rep.snapshot.indexOf(id) === -1) newArrived = true;
    });
    if (present.length && newArrived) {
      return present.reduce(function (acc, id) { return acc.then(function () { return changeById(id, 0); }); }, Promise.resolve())
        .then(function () { s.replacing = null; write(s); return true; });
    }
    if (!present.length) { s.replacing = null; write(s); }
    return Promise.resolve(false);
  }

  /* ======================================================================
     Observation du panier (reflet live)
     ====================================================================== */
  var CART_ROUTES = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var observerInstalled = false;
  function notifyCartChange() {
    try { document.dispatchEvent(new CustomEvent('ps:cart-changed')); } catch (e) {}
  }
  function installCartObserver() {
    if (observerInstalled) return;
    observerInstalled = true;
    var wrapped = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : ((input && input.url) || '');
      var p = wrapped.apply(this, arguments);
      if (CART_ROUTES.test(url)) p.then(notifyCartChange, function () {});
      return p;
    };
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) { this.__psUrl = url || ''; return open.apply(this, arguments); };
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (CART_ROUTES.test(this.__psUrl || '')) this.addEventListener('loadend', notifyCartChange);
      return send.apply(this, arguments);
    };
    ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
      document.addEventListener(ev, notifyCartChange);
    });
    /* Filet de sécurité : si un composant garde une référence à l'ancien
       fetch, on compare quand même la signature du panier toutes les 4 s. */
    var lastSig = null;
    setInterval(function () {
      if (document.visibilityState !== 'visible') return;
      getCart().then(function (c) {
        var sig = (c.items || []).map(function (i) { return i.key + ':' + i.quantity + ':' + i.final_line_price; }).join('|');
        if (lastSig !== null && sig !== lastSig) notifyCartChange();
        lastSig = sig;
      }).catch(function () {});
    }, 4000);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') notifyCartChange();
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) notifyCartChange(); });
  }

  /* ======================================================================
     Interface : styles, loader, stepper
     ====================================================================== */
  var CSS = [
    ':root{--ps-orange:#E8620A;--ps-orange-soft:#FFF1E6;--ps-ink:#1d1611;--ps-muted:#7c7168;--ps-line:#efe5dc;--ps-cream:#FFF8F3;}',
    '.ps-lock{overflow:hidden!important}',
    '.ps-hidden{display:none!important}',
    '.ps-reveal{animation:ps-rise .35s ease-out both}',
    '@keyframes ps-rise{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}',
    '@keyframes ps-fade{from{opacity:0}to{opacity:1}}',
    '@keyframes ps-slide{0%{transform:translateX(-110%)}100%{transform:translateX(260%)}}',
    '@keyframes ps-pulse{0%,100%{box-shadow:0 0 0 5px rgba(232,98,10,.16)}50%{box-shadow:0 0 0 9px rgba(232,98,10,.06)}}',

    /* Loader */
    '.ps-loader{position:fixed;inset:0;z-index:2147483647;display:grid;place-items:center;padding:24px;background:rgba(255,248,243,.94);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);animation:ps-fade .18s ease-out;font-family:inherit}',
    '.ps-loader__card{width:min(440px,100%);background:#fff;border-radius:22px;padding:30px 26px 26px;text-align:center;box-shadow:0 24px 60px rgba(232,98,10,.14),0 2px 10px rgba(29,22,17,.05)}',
    '.ps-loader__brand{font-family:var(--font-heading--family,inherit);font-weight:700;font-size:26px;line-height:1;color:var(--ps-orange);margin:0 0 22px}',
    '.ps-loader__msg{margin-top:22px;font-size:17px;font-weight:600;color:var(--ps-ink)}',
    '.ps-loader__sub{margin-top:6px;font-size:13.5px;color:var(--ps-muted)}',
    '.ps-loader__bar{position:relative;height:4px;margin-top:22px;border-radius:4px;background:#f3ebe3;overflow:hidden}',
    '.ps-loader__bar span{position:absolute;top:0;bottom:0;left:0;width:40%;border-radius:4px;background:var(--ps-orange);animation:ps-slide 1.1s cubic-bezier(.45,0,.2,1) infinite}',

    /* Stepper */
    '.ps-stepper{list-style:none;margin:0;padding:0;display:flex;align-items:flex-start;justify-content:center}',
    '.ps-step{position:relative;flex:1 1 0;min-width:0;display:flex;flex-direction:column;align-items:center;text-align:center}',
    '.ps-step+.ps-step:before{content:"";position:absolute;top:17px;left:-50%;right:50%;height:3px;border-radius:3px;background:var(--ps-line)}',
    '.ps-step--done+.ps-step:before{background:var(--ps-orange)}',
    '.ps-step__dot{position:relative;z-index:1;width:36px;height:36px;border-radius:50%;display:grid;place-items:center;font-size:14px;font-weight:700;background:#fff;border:2px solid var(--ps-line);color:#b3a79c;transition:background .25s,border-color .25s,color .25s}',
    '.ps-step__dot svg{width:16px;height:16px}',
    '.ps-step--done .ps-step__dot{background:var(--ps-orange);border-color:var(--ps-orange);color:#fff}',
    '.ps-step--current .ps-step__dot{border-color:var(--ps-orange);animation:ps-pulse 2s ease-in-out infinite}',
    '.ps-step--current:not(.ps-step--done) .ps-step__dot{color:var(--ps-orange)}',
    '.ps-step__text{display:flex;flex-direction:column;gap:1px;margin-top:8px;padding:0 4px;max-width:100%}',
    '.ps-step__name{font-size:13px;font-weight:700;color:var(--ps-ink);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.ps-step--todo .ps-step__name{color:#b3a79c}',
    '.ps-step__hint{font-size:11.5px;color:var(--ps-muted);white-space:nowrap}',
    '.ps-step--link{cursor:pointer}',
    '.ps-step--link:hover .ps-step__dot{border-color:var(--ps-orange)}',
    '.ps-step--link:focus-visible{outline:2px solid var(--ps-orange);outline-offset:4px;border-radius:12px}',
    '.ps-stepper--compact .ps-step__dot{width:30px;height:30px;font-size:13px}',
    '.ps-stepper--compact .ps-step+.ps-step:before{top:14px}',
    '@media (max-width:640px){.ps-step__hint{display:none}.ps-step__name{font-size:11.5px}.ps-step__dot{width:32px;height:32px}.ps-step+.ps-step:before{top:15px}}',

    /* Liens et boutons */
    '.ps-link{background:none;border:0;padding:0;font:inherit;font-size:13px;color:var(--ps-muted);text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
    '.ps-link:hover{color:var(--ps-orange)}',
    '.ps-btn{display:inline-flex;align-items:center;justify-content:center;gap:6px;border-radius:12px;padding:12px 18px;font:inherit;font-size:14px;font-weight:700;line-height:1.1;cursor:pointer;text-decoration:none;border:2px solid var(--ps-orange);transition:background .15s,color .15s,border-color .15s}',
    '.ps-btn--primary{background:var(--ps-orange);color:#fff}',
    '.ps-btn--primary:hover{background:#d4570a;border-color:#d4570a;color:#fff}',
    '.ps-btn--ghost{background:#fff;color:var(--ps-orange)}',
    '.ps-btn--ghost:hover{background:var(--ps-orange-soft)}',
    '.ps-btn--quiet{background:#fff;color:var(--ps-ink);border-color:var(--ps-line);font-weight:600}',
    '.ps-btn--quiet:hover{border-color:var(--ps-orange);color:var(--ps-orange)}',
    '.ps-btn--small{padding:8px 12px;font-size:13px;border-radius:10px;border-width:1.5px}',
    '.ps-btn[disabled],.ps-btn--disabled{opacity:.45;pointer-events:none}',

    /* Barre de la page compose */
    '.ps-bar{background:rgba(255,255,255,.97);border-bottom:1px solid var(--ps-line);padding:14px 16px 16px}',
    '.ps-bar__inner{max-width:880px;margin:0 auto}',
    '.ps-bar__top{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:14px}',
    '.ps-bar__title{font-size:13px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--ps-ink)}',
    '.ps-bar__title b{color:var(--ps-orange)}',
    '.ps-bar__links{display:flex;gap:16px;align-items:center}',
    '.ps-bar--idle{background:var(--ps-cream);border-bottom:0;text-align:center;padding:18px 16px}',
    '.ps-bar--idle p{margin:0 0 10px;color:var(--ps-ink);font-size:15px}',
    '.ps-stephead{text-align:center;padding:26px 16px 4px}',
    '.ps-stephead__kicker{display:inline-block;padding:6px 14px;border-radius:999px;background:var(--ps-orange-soft);color:var(--ps-orange);font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase}',
    '.ps-stephead__sub{margin:10px 0 0;color:var(--ps-muted);font-size:15px}',
    '.ps-stephead__done{margin-top:14px;display:flex;gap:10px;justify-content:center;flex-wrap:wrap}',

    /* Bannière fiche produit */
    '.ps-pbar{background:var(--ps-ink);color:#fff;font-family:inherit}',
    '.ps-pbar__inner{max-width:1200px;margin:0 auto;padding:10px 16px;display:flex;align-items:center;justify-content:space-between;gap:10px 18px;flex-wrap:wrap}',
    '.ps-pbar__left{display:flex;align-items:center;gap:12px;min-width:0;flex-wrap:wrap}',
    '.ps-pbar__badge{background:var(--ps-orange);border-radius:999px;padding:4px 11px;font-size:12px;font-weight:700;white-space:nowrap}',
    '.ps-pbar__msg{font-size:14px;line-height:1.35}',
    '.ps-pbar__dots{display:inline-flex;gap:6px;align-items:center}',
    '.ps-pbar__dots i{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.28)}',
    '.ps-pbar__dots i.on{background:var(--ps-orange)}',
    '.ps-pbar__dots i.cur{background:#fff;box-shadow:0 0 0 3px rgba(255,255,255,.2)}',
    '.ps-pbar__actions{display:flex;gap:16px;align-items:center}',
    '.ps-pbar .ps-link{color:rgba(255,255,255,.78)}',
    '.ps-pbar .ps-link:hover{color:#fff}',

    /* Récap */
    '.ps-summary{max-width:1080px;margin:0 auto;padding:8px 20px 64px;color:var(--ps-ink)}',
    '.ps-summary__stepper{max-width:640px;margin:0 auto 28px}',
    '.ps-grid{display:grid;grid-template-columns:minmax(0,1fr) 360px;gap:24px;align-items:start}',
    '@media (max-width:900px){.ps-grid{grid-template-columns:1fr}}',
    '.ps-steps{display:flex;flex-direction:column;gap:14px}',
    '.ps-card{background:#fff;border:1px solid var(--ps-line);border-radius:18px;padding:18px}',
    '.ps-card--empty{border-style:dashed;background:#fffdfb}',
    '.ps-card__head{display:flex;align-items:center;gap:12px}',
    '.ps-card__num{flex:none;width:32px;height:32px;border-radius:50%;display:grid;place-items:center;font-weight:700;font-size:14px;background:var(--ps-orange);color:#fff}',
    '.ps-card--empty .ps-card__num{background:#fff;color:#b3a79c;border:2px solid var(--ps-line)}',
    '.ps-card__kicker{font-size:12px;font-weight:700;letter-spacing:.07em;text-transform:uppercase;color:var(--ps-orange)}',
    '.ps-card__count{font-size:14px;color:var(--ps-muted);margin-top:2px}',
    '.ps-card__count b{color:var(--ps-ink)}',
    '.ps-lines{list-style:none;margin:14px 0 0;padding:0;display:flex;flex-direction:column;gap:10px}',
    '.ps-line{display:flex;align-items:center;gap:14px;padding:10px;border-radius:14px;background:var(--ps-cream)}',
    '.ps-line__img{flex:none;width:64px;height:64px;border-radius:12px;background:#fff;object-fit:contain}',
    '.ps-line__body{flex:1;min-width:0}',
    '.ps-line__title{font-weight:700;font-size:15px;line-height:1.3}',
    '.ps-line__qty{font-size:13px;color:var(--ps-muted);margin-top:2px}',
    '.ps-line__actions{display:flex;gap:8px;flex-wrap:wrap;margin-top:8px}',
    '.ps-card__foot{display:flex;gap:10px;flex-wrap:wrap;margin-top:12px}',
    '.ps-empty-cta{margin-top:12px}',
    '.ps-side{position:sticky;top:90px;display:flex;flex-direction:column;gap:14px}',
    '@media (max-width:900px){.ps-side{position:static}}',
    '.ps-total{background:#fff;border:2px solid var(--ps-orange);border-radius:18px;padding:20px}',
    '.ps-total__title{font-size:13px;font-weight:700;letter-spacing:.07em;text-transform:uppercase;color:var(--ps-muted);margin-bottom:12px}',
    '.ps-row{display:flex;justify-content:space-between;gap:12px;padding:7px 0;font-size:14.5px;font-variant-numeric:tabular-nums}',
    '.ps-row dd{margin:0;font-weight:700;white-space:nowrap}',
    '.ps-row dt{color:var(--ps-ink)}',
    '.ps-row--sub{padding:2px 0 2px 12px;font-size:13px;color:var(--ps-muted)}',
    '.ps-row--sub dt,.ps-row--sub dd{color:var(--ps-muted);font-weight:500}',
    '.ps-total__sum{display:flex;justify-content:space-between;align-items:baseline;gap:12px;margin-top:10px;padding-top:12px;border-top:1px solid var(--ps-line)}',
    '.ps-total__sum span{font-weight:700;font-size:15px}',
    '.ps-total__sum strong{font-size:28px;line-height:1;color:var(--ps-orange);font-variant-numeric:tabular-nums}',
    '.ps-total__orig{text-align:right;font-size:13px;color:var(--ps-muted);text-decoration:line-through;margin-top:4px}',
    '.ps-save{margin-top:10px;padding:8px 12px;border-radius:10px;background:#EAF7EE;color:#1f7a3a;font-size:13.5px;font-weight:600;text-align:center}',
    '.ps-tip{margin-top:10px;padding:8px 12px;border-radius:10px;background:var(--ps-orange-soft);color:#9a4308;font-size:13px;text-align:center}',
    '.ps-note{margin:10px 0 0;font-size:12.5px;color:var(--ps-muted);text-align:center}',
    '.ps-sac{background:#fff;border:1px solid var(--ps-line);border-radius:18px;padding:16px}',
    '.ps-sac--ask{border:2px dashed var(--ps-orange);background:var(--ps-cream)}',
    '.ps-sac__row{display:flex;gap:14px;align-items:center}',
    '.ps-sac__img{flex:none;width:72px;height:72px;border-radius:12px;object-fit:cover;background:#fff}',
    '.ps-sac__title{font-weight:700;font-size:15px}',
    '.ps-sac__text{font-size:13px;color:var(--ps-muted);margin-top:3px;line-height:1.4}',
    '.ps-sac__actions{display:flex;gap:10px;margin-top:12px;flex-wrap:wrap}',
    '.ps-sac__actions .ps-btn{flex:1 1 auto}',
    '.ps-sac--no{display:flex;justify-content:space-between;align-items:center;gap:10px;font-size:13.5px;color:var(--ps-muted)}',
    '.ps-cta{width:100%;padding:16px 20px;font-size:16px;letter-spacing:.02em}',
    '.ps-foot{display:flex;justify-content:center;gap:18px;flex-wrap:wrap}',
    '.ps-notice{max-width:640px;margin:0 auto 18px;padding:12px 16px;border-radius:12px;background:#FFF4D6;color:#7a5400;font-size:14px;text-align:center}',
    '.ps-blank{max-width:520px;margin:20px auto;text-align:center;padding:40px 24px;border:2px dashed var(--ps-line);border-radius:20px}',
    '.ps-blank h2{font-family:var(--font-heading--family,inherit);color:var(--ps-orange);margin:0 0 8px}',
    '.ps-blank p{color:var(--ps-muted);margin:0 0 18px}',
    '.ps-skeleton{height:120px;border-radius:18px;background:linear-gradient(90deg,#f6efe8 0%,#fbf6f1 50%,#f6efe8 100%);background-size:200% 100%;animation:ps-shimmer 1.2s linear infinite}',
    '@keyframes ps-shimmer{from{background-position:200% 0}to{background-position:-200% 0}}',
    '@media (prefers-reduced-motion:reduce){.ps-loader,.ps-reveal,.ps-step--current .ps-step__dot,.ps-skeleton{animation:none!important}.ps-loader__bar span{animation:none;width:100%}}'
  ].join('\n');

  function injectCss() {
    if (document.getElementById('ps-styles')) return;
    var st = document.createElement('style');
    st.id = 'ps-styles';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    return (Math.round(cents) / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }
  var CHECK = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var BAG = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 5.5h10l-.8 8H3.8L3 5.5zM5.5 5.5V4a2.5 2.5 0 015 0v1.5" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';

  /*
   * current : 0-3 = étape en cours, 4 = récap, null = aucune
   * done    : [bool x4]
   * o.compact, o.recap (ajoute l'étape Récap), o.links (étapes cliquables)
   */
  function stepperHTML(current, done, o) {
    o = o || {};
    done = done || [false, false, false, false];
    var html = STEPS.map(function (s, i) {
      var cls = ['ps-step'];
      cls.push(done[i] ? 'ps-step--done' : 'ps-step--todo');
      if (i === current) cls.push('ps-step--current');
      var link = o.links && (done[i] || i === current);
      if (link) cls.push('ps-step--link');
      return '<li class="' + cls.join(' ') + '"' +
        (link ? ' data-ps-step="' + i + '" role="button" tabindex="0"' : '') +
        ' aria-label="Étape ' + (i + 1) + ' : ' + esc(s.name) + (done[i] ? ' (faite)' : '') + '"' +
        (i === current ? ' aria-current="step"' : '') + '>' +
        '<span class="ps-step__dot">' + (done[i] ? CHECK : (i + 1)) + '</span>' +
        (o.compact ? '' : '<span class="ps-step__text"><span class="ps-step__name">' + esc(s.name) + '</span><span class="ps-step__hint">' + esc(s.hint) + '</span></span>') +
        '</li>';
    }).join('');
    if (o.recap) {
      var ready = done.every(Boolean);
      var rc = ['ps-step', current === 4 ? 'ps-step--current' : (ready ? 'ps-step--todo' : 'ps-step--todo')];
      var rlink = o.links && ready;
      if (rlink) rc.push('ps-step--link');
      html += '<li class="' + rc.join(' ') + '"' + (rlink ? ' data-ps-step="recap" role="button" tabindex="0"' : '') +
        (current === 4 ? ' aria-current="step"' : '') + '>' +
        '<span class="ps-step__dot">' + BAG + '</span>' +
        (o.compact ? '' : '<span class="ps-step__text"><span class="ps-step__name">Récap</span><span class="ps-step__hint">Ton pack</span></span>') +
        '</li>';
    }
    return '<ol class="ps-stepper' + (o.compact ? ' ps-stepper--compact' : '') + '">' + html + '</ol>';
  }

  function showLoader(message, opts) {
    if (isEditor) return;
    opts = opts || {};
    injectCss();
    var el = document.getElementById('ps-loader');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ps-loader';
      el.className = 'ps-loader';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.documentElement.appendChild(el);
      document.documentElement.classList.add('ps-lock');
    }
    var stepper = (opts.step !== undefined || opts.done)
      ? stepperHTML(opts.step === undefined ? null : opts.step, opts.done, { compact: true, recap: true })
      : '';
    el.innerHTML =
      '<div class="ps-loader__card">' +
        '<p class="ps-loader__brand">Pack Summer</p>' + stepper +
        '<p class="ps-loader__msg">' + esc(message || 'Un instant…') + '</p>' +
        (opts.sub ? '<p class="ps-loader__sub">' + esc(opts.sub) + '</p>' : '') +
        '<div class="ps-loader__bar"><span></span></div>' +
      '</div>';
  }
  function hideLoader() {
    var el = document.getElementById('ps-loader');
    if (el) el.remove();
    document.documentElement.classList.remove('ps-lock');
  }
  /* Si le navigateur restaure la page depuis le cache après une redirection,
     le loader ne doit pas rester affiché. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) hideLoader(); });

  /* ======================================================================
     Navigation dans le parcours
     ====================================================================== */
  function go(url, delay) {
    setTimeout(function () { window.location.href = url; }, delay || 0);
  }

  /* Démarrer (ou reprendre) depuis un bouton « Composer mon pack ». */
  function startPack() {
    var s = ensureActive();
    showLoader('On prépare ton pack', { step: s.currentStep || 0, done: [false, false, false, false] });
    Promise.all([getCart(), loadCollections()]).then(function (r) {
      var a = analyse(r[0], r[1]);
      s.seenKeys = a.keys; s.seenQty = a.qtys;
      var next = a.filled.indexOf(false);
      s.currentStep = next === -1 ? 0 : next;
      touch(s);
      if (next === -1) {
        showLoader('Ton pack est déjà complet', { step: 4, done: a.filled });
        go(URLS.summary, 350);
      } else {
        showLoader(next === 0 ? 'C\'est parti !' : 'On reprend où tu t\'étais arrêté', { step: next, done: a.filled, sub: 'Étape ' + (next + 1) + ' sur 4 — ' + STEPS[next].name });
        go(URLS.compose + '#etape-' + (next + 1), 350);
      }
    }).catch(function () {
      touch(s);
      go(URLS.compose + '#etape-1');
    });
  }

  function editUrl(item) {
    var params = [];
    if (item.variant_id) params.push('variant=' + item.variant_id);
    var p = item.properties || {};
    if (p._mczr_designId) params.push('designId=' + encodeURIComponent(p._mczr_designId));
    var token = p._mczr_designProtectionToken;
    if (!token) {
      Object.keys(p).forEach(function (k) { if (!token && /token/i.test(k) && String(p[k]).length > 20) token = p[k]; });
    }
    if (token) params.push('token=' + encodeURIComponent(token));
    return '/products/' + item.handle + (params.length ? '?' + params.join('&') : '');
  }

  /* ======================================================================
     Page : intro
     ====================================================================== */
  function initIntro() {
    if (isEditor) return;
    var bound = 0;
    var els = document.querySelectorAll('a, button');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-ps-bound') === '1') continue;
      var t = (el.textContent || '').trim().toUpperCase();
      var isStart = el.hasAttribute('data-pack-summer-start') ||
        t.indexOf('COMPOSER MON PACK') !== -1 || t.indexOf('COMPOSE TON PACK') !== -1 ||
        t.indexOf('COMPOSER TON PACK') !== -1 || t.indexOf('CRÉER MON PACK') !== -1 ||
        t.indexOf('CRÉE TON PACK') !== -1;
      if (!isStart) continue;
      el.setAttribute('data-ps-bound', '1');
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        startPack();
      }, true);
      bound++;
    }
    console.log('[PackSummer] ' + bound + ' bouton(s) « composer » lié(s)');
  }

  /* ======================================================================
     Page : compose (une étape à la fois)
     ====================================================================== */
  var SECTION_MATCHERS = ['LA BASE', 'INGRÉDIENT', 'PROTÉINE', 'SAUCE'];
  var STEP_SUBS = [
    'Choisis ton haut, personnalise-le, puis ajoute-le au panier.',
    'Choisis ton bas, personnalise-le, puis ajoute-le au panier.',
    'Choisis ton dessous, personnalise-le, puis ajoute-le au panier.',
    'Choisis ton accessoire, personnalise-le, puis ajoute-le au panier.'
  ];

  function findStepSections() {
    var found = [null, null, null, null];
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (section) {
      if (section.querySelector('#ps-compose-bar')) return;
      section.querySelectorAll('h1, h2, h3, [class*="heading"], [class*="title"]').forEach(function (h) {
        var text = (h.textContent || '').trim().toUpperCase();
        for (var i = 0; i < 4; i++) {
          if (!found[i] && text.indexOf(SECTION_MATCHERS[i]) !== -1) found[i] = section;
        }
      });
    });
    return found;
  }

  function initCompose(mount) {
    if (isEditor || !mount) return;
    injectCss();
    installCartObserver();
    var sections = findStepSections();
    var s = getActive();

    if (!s) {
      /* Pas de parcours : la page reste un catalogue normal, avec une invitation. */
      mount.innerHTML =
        '<div class="ps-bar ps-bar--idle"><p>Compose ton Pack Summer étape par étape et profite du prix pack.</p>' +
        '<button type="button" class="ps-btn ps-btn--primary" data-ps-start>Composer mon pack</button></div>';
      mount.querySelector('[data-ps-start]').addEventListener('click', startPack);
      return;
    }

    var state = { current: 0, done: [false, false, false, false], names: [[], [], [], []] };

    function currentFromHash() {
      var m = (location.hash || '').match(/etape-(\d)/);
      if (m) { var n = parseInt(m[1], 10) - 1; if (n >= 0 && n <= 3) return n; }
      return typeof s.currentStep === 'number' ? s.currentStep : 0;
    }

    function renderBar() {
      var anyDone = state.done.some(Boolean);
      mount.innerHTML =
        '<div class="ps-bar" id="ps-compose-bar"><div class="ps-bar__inner">' +
          '<div class="ps-bar__top">' +
            '<span class="ps-bar__title">Pack Summer · <b>Étape ' + (state.current + 1) + ' sur 4</b></span>' +
            '<span class="ps-bar__links">' +
              (anyDone ? '<button type="button" class="ps-link" data-ps-recap>Voir mon récap</button>' : '') +
              '<button type="button" class="ps-link" data-ps-quit>Quitter le pack</button>' +
            '</span>' +
          '</div>' +
          stepperHTML(state.current, state.done, { links: true, recap: true }) +
        '</div></div>';
      mount.querySelectorAll('[data-ps-step]').forEach(function (el) {
        function activate() {
          var v = el.getAttribute('data-ps-step');
          if (v === 'recap') { go(URLS.summary); return; }
          location.hash = 'etape-' + (parseInt(v, 10) + 1);
        }
        el.addEventListener('click', activate);
        el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); } });
      });
      var recap = mount.querySelector('[data-ps-recap]');
      if (recap) recap.addEventListener('click', function () { go(URLS.summary); });
      mount.querySelector('[data-ps-quit]').addEventListener('click', quit);
    }

    function quit() {
      exitPack();
      showLoader('Tu quittes le parcours', { sub: 'Ton panier est conservé.' });
      go(URLS.intro, 450);
    }

    function renderSection() {
      sections.forEach(function (sec, i) {
        if (!sec) return;
        var old = sec.querySelector('.ps-stephead');
        if (old) old.remove();
        if (i !== state.current) { sec.classList.add('ps-hidden'); sec.classList.remove('ps-reveal'); return; }
        sec.classList.remove('ps-hidden');
        sec.classList.add('ps-reveal');
        var head = document.createElement('div');
        head.className = 'ps-stephead';
        var mode = s.pendingMode;
        var sub = mode === 'change' ? 'Choisis le modèle qui remplacera l\'ancien.'
          : mode === 'extra' ? 'Choisis un modèle en plus pour cette étape.'
          : STEP_SUBS[i];
        var doneBlock = '';
        if (state.done[i] && !mode) {
          var nextEmpty = state.done.indexOf(false);
          sub = 'Déjà choisi : ' + state.names[i].join(', ') + '. Tu peux ajouter un autre modèle ou continuer.';
          doneBlock = '<div class="ps-stephead__done">' +
            (nextEmpty === -1
              ? '<button type="button" class="ps-btn ps-btn--primary ps-btn--small" data-ps-next="recap">Voir mon récap →</button>'
              : '<button type="button" class="ps-btn ps-btn--primary ps-btn--small" data-ps-next="' + nextEmpty + '">Étape suivante →</button>') +
            '</div>';
        }
        head.innerHTML =
          '<span class="ps-stephead__kicker">Étape ' + (i + 1) + ' sur 4 · ' + esc(STEPS[i].hint) + '</span>' +
          '<p class="ps-stephead__sub">' + esc(sub) + '</p>' + doneBlock;
        sec.insertBefore(head, sec.firstChild);
        var nb = head.querySelector('[data-ps-next]');
        if (nb) nb.addEventListener('click', function () {
          var v = nb.getAttribute('data-ps-next');
          if (v === 'recap') go(URLS.summary); else location.hash = 'etape-' + (parseInt(v, 10) + 1);
        });
      });
    }

    function render() {
      state.current = currentFromHash();
      s.currentStep = state.current;
      touch(s);
      renderBar();
      renderSection();
    }

    /* Armer le produit choisi dans l'étape visible. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/products/"]');
      if (!a) return;
      var sec = sections[state.current];
      if (!sec || !sec.contains(a)) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var st = getActive();
      if (!st) return;
      var mode = st.pendingMode || 'add';
      if (st.replacing && typeof st.replacing.step === 'number' && st.replacing.step !== state.current) {
        mode = 'add'; st.replacing = null; st.pendingMode = null; st.changingStep = null;
      }
      st.armed = { handle: decodeURIComponent(m[1]), step: state.current, mode: mode, at: now() };
      touch(st);
      s = st;
    }, true);

    window.addEventListener('hashchange', function () { render(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
    document.addEventListener('ps:cart-changed', refreshFromCart);

    function refreshFromCart() {
      Promise.all([getCart(), loadCollections()]).then(function (r) {
        var an = analyse(r[0], r[1]);
        state.done = an.filled;
        state.names = an.slots.map(function (ls) { return ls.map(function (l) { return l.item.product_title; }); });
        s.seenKeys = an.keys; s.seenQty = an.qtys;
        write(s);
        render();
      }).catch(function () {});
    }

    hideLoader();
    render();
    refreshFromCart();
  }

  /* ======================================================================
     Page : fiche produit
     ====================================================================== */
  function initProduct() {
    if (isEditor) return;
    var s = getActive();
    if (!s) return;
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    var armed = armedFor(s, handle);
    if (!armed) return;   /* produit ouvert hors parcours : aucune bannière */

    injectCss();
    touch(s);
    /* Si Kickflip ajoute au panier sans passer par /cart, on aiguille d'ici. */
    installCartObserver();
    var fallback = null;
    document.addEventListener('ps:cart-changed', function () {
      clearTimeout(fallback);
      fallback = setTimeout(function () { routeArmed(false); }, 2500);
    });
    /* retour navigateur (bfcache) sur une fiche qui n'est plus armée : retirer la bannière */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      if (!armedFor(getActive(), handle)) { var b = document.getElementById('ps-product-bar'); if (b) b.remove(); }
    });
    Promise.all([getCart(), loadCollections()]).then(function (r) {
      return analyse(r[0], r[1]).filled;
    }).catch(function () { return [false, false, false, false]; }).then(function (done) {
      var mode = armed.mode;
      var step = armed.step;
      var badge, msg, back, backUrl;
      if (mode === 'sac') {
        badge = 'Option · Sac à dos';
        msg = '20 € le sac avec ton pack. Personnalise-le, puis ajoute-le au panier.';
        back = '← Revenir au récap'; backUrl = URLS.summary;
      } else if (mode === 'edit') {
        badge = 'Modification';
        msg = 'Modifie ton modèle puis ajoute-le au panier : il remplacera l\'ancien.';
        back = '← Annuler et revenir au récap'; backUrl = URLS.summary;
      } else if (mode === 'change') {
        badge = 'Changement';
        msg = 'Personnalise ce modèle : il remplacera l\'ancien.';
        back = '← Revenir au récap'; backUrl = URLS.summary;
      } else if (mode === 'extra') {
        badge = 'Modèle en plus';
        msg = 'Personnalise ce modèle supplémentaire, puis ajoute-le au panier.';
        back = '← Revenir au récap'; backUrl = URLS.summary;
      } else {
        badge = 'Étape ' + (step + 1) + ' sur 4';
        msg = STEPS[step] ? 'Personnalise ' + STEPS[step].hint.toLowerCase() + ', puis ajoute-le au panier.' : 'Personnalise ton produit, puis ajoute-le au panier.';
        back = '← Choisir un autre modèle'; backUrl = URLS.compose + '#etape-' + (step + 1);
      }
      var dots = [0, 1, 2, 3].map(function (i) {
        return '<i class="' + (done[i] ? 'on' : '') + (i === step ? ' cur' : '') + '"></i>';
      }).join('');
      var bar = document.createElement('div');
      bar.className = 'ps-pbar';
      bar.id = 'ps-product-bar';
      bar.innerHTML =
        '<div class="ps-pbar__inner">' +
          '<div class="ps-pbar__left">' +
            '<span class="ps-pbar__badge">' + esc(badge) + '</span>' +
            (mode === 'sac' ? '' : '<span class="ps-pbar__dots" aria-hidden="true">' + dots + '</span>') +
            '<span class="ps-pbar__msg">' + esc(msg) + '</span>' +
          '</div>' +
          '<div class="ps-pbar__actions">' +
            '<button type="button" class="ps-link" data-ps-back>' + esc(back) + '</button>' +
            '<button type="button" class="ps-link" data-ps-quit>Quitter le pack</button>' +
          '</div>' +
        '</div>';
      document.body.insertBefore(bar, document.body.firstChild);
      bar.querySelector('[data-ps-back]').addEventListener('click', function () {
        var st = getActive();
        if (st) { st.armed = null; if (mode === 'edit' || mode === 'change') st.replacing = null; st.pendingMode = null; touch(st); }
        go(backUrl);
      });
      bar.querySelector('[data-ps-quit]').addEventListener('click', function () {
        exitPack();
        bar.remove();
      });
    });
  }

  /* ======================================================================
     Page : panier (aiguillage après ajout)
     ====================================================================== */
  var routing = false;
  /* Aiguillage après ajout du produit armé. `early` : afficher le loader
     avant de vérifier (page panier, où l'on arrive juste après l'ajout). */
  /* Kickflip enchaîne lui-même /cart/add.js puis location.assign('/cart').
     La fiche produit voit l'ajout, décide la suite et consomme l'armement,
     mais sa navigation perd la course contre celle de Kickflip : la page
     panier trouvait un état désarmé et ne faisait rien (constaté le 16/09).
     La décision est donc écrite dans l'état (`redirectTo`) avant de naviguer,
     et la page qui arrive ensuite la suit. */
  function followPending(s) {
    var r = s && s.redirectTo;
    if (!r || !r.url) return false;
    s.redirectTo = null; write(s);
    if (now() - (r.at || 0) > 2 * 60 * 1000) return false;
    if (location.pathname === r.url.split('#')[0]) return false;
    routing = true;
    showLoader(r.msg || 'Un instant…', r.opts || { step: 4 });
    go(r.url, 150);
    return true;
  }
  function routeArmed(early) {
    if (isEditor || routing) return;
    var s = getActive();
    if (!s) return;
    if (followPending(s)) return;
    var armed = armedFor(s);
    if (!armed) return;   /* rien d'armé : panier normal, aucune redirection */

    var modeMsg = { add: 'On ajoute ton produit au pack', edit: 'On enregistre ta modification', change: 'On remplace ton modèle', extra: 'On ajoute ton modèle en plus', sac: 'On ajoute ton sac à dos' };
    var loaderStep = typeof armed.step === 'number' ? armed.step : 4;
    routing = true;
    if (early) showLoader(modeMsg[armed.mode] || 'Un instant…', { step: loaderStep });

    Promise.all([getCart(), loadCollections()]).then(function (r) {
      var cart = r[0], cols = r[1];
      var seen = Array.isArray(s.seenKeys) ? s.seenKeys : [];
      var seenQty = s.seenQty || {};
      var replacingMode = armed.mode === 'edit' || armed.mode === 'change';
      var fresh = (cart.items || []).filter(function (it) {
        return it.handle === armed.handle && seen.indexOf(lineId(it)) === -1;
      });
      /* Même design rajouté tel quel : Shopify fusionne dans la ligne existante
         (même clé, quantité native +1) au lieu d'en créer une. */
      var grown = (cart.items || []).filter(function (it) {
        var id = lineId(it);
        return it.handle === armed.handle && seen.indexOf(id) !== -1 &&
          seenQty[id] != null && it.quantity > seenQty[id];
      });
      var fixes = [];
      if (replacingMode) {
        /* « Modifier » validé sans changement : on annule le doublon. */
        grown.forEach(function (it) { fixes.push({ id: lineId(it), quantity: seenQty[lineId(it)] }); });
        /* double clic sur « Ajouter » : une ligne neuve ne vaut qu'un exemplaire */
        fresh.forEach(function (it) { if (it.quantity > 1) fixes.push({ id: lineId(it), quantity: 1 }); });
      }
      if (!fresh.length && !grown.length) {   /* pas l'ajout attendu : on ne touche à rien */
        if (early) hideLoader();
        routing = false;
        return null;
      }
      if (!early) showLoader(modeMsg[armed.mode] || 'Un instant…', { step: loaderStep });

      var p = fixes.reduce(function (acc, f) {
        return acc.then(function () { return changeById(f.id, f.quantity); });
      }, Promise.resolve());
      if (fixes.length) p = p.then(function () { return getCart().then(function (c) { cart = c; }); });
      /* une fusion seule (aucune ligne neuve) n'est pas un remplacement : rien à retirer */
      if (replacingMode && s.replacing && fresh.length) {
        p = p.then(function () {
          return reconcileReplacement(s, cart, cols).then(function (removed) {
            if (removed) return getCart().then(function (c) { cart = c; });
          });
        });
      }
      return p.then(function () {
        var an = analyse(cart, cols);
        if (armed.mode === 'sac') s.sacChoice = 'yes';
        s.armed = null; s.pendingMode = null; s.replacing = null;
        s.editingStep = null; s.changingStep = null;
        s.replacingKey = null; s.replacingStep = null; s.replacingSnapshot = null; s.upsellStep = false;
        s.seenKeys = an.keys; s.seenQty = an.qtys;
        var next = an.filled.indexOf(false);
        var toSummary = armed.mode !== 'add' || next === -1;
        if (!toSummary) s.currentStep = next;
        var rd = toSummary
          ? { url: URLS.summary, msg: next === -1 ? 'Ton pack est complet 🎉' : 'Retour à ton récap', opts: { step: 4, done: an.filled } }
          : { url: URLS.compose + '#etape-' + (next + 1), msg: 'C\'est ajouté !', opts: { step: next, done: an.filled, sub: 'Étape suivante : ' + STEPS[next].name + ' — ' + STEPS[next].hint.toLowerCase() } };
        rd.at = now();
        s.redirectTo = rd;   /* écrit AVANT de naviguer : voir followPending */
        touch(s);
        showLoader(rd.msg, rd.opts);
        go(rd.url, early ? 450 : 0);
        return null;
      });
    }).catch(function (e) {
      console.error('[PackSummer] aiguillage panier :', e);
      hideLoader();
      routing = false;
    });
  }

  function initCartRouter() {
    routeArmed(true);
    /* passage obligé avant le paiement : on y recopie les quantités cachées
       (voir syncDesignQtyAttribute), parcours en cours ou non */
    if (!routing && !isEditor) getCart().catch(function () {});
  }

  /* ======================================================================
     Page : récap
     ====================================================================== */
  function initSummary(mount) {
    if (isEditor || !mount) return;
    injectCss();
    installCartObserver();
    hideLoader();
    mount.innerHTML = '<div class="ps-summary"><div class="ps-skeleton"></div></div>';

    var busy = false, again = false, lastCart = null;

    function schedule() {
      if (busy) { again = true; return; }
      render();
    }
    document.addEventListener('ps:cart-changed', function () { setTimeout(schedule, 120); });

    function stateForAction() {
      var s = ensureActive();
      if (lastCart) s.seenKeys = lastCart.items.map(function (i) { return i.key; });
      return s;
    }

    function actEdit(step, item) {
      var s = stateForAction();
      s.replacing = { key: item.key, step: step, snapshot: s.seenKeys.slice() };
      s.armed = { handle: item.handle, step: step, mode: 'edit', at: now() };
      s.pendingMode = null;
      s.editingStep = step === 'sac' ? null : step;
      touch(s);
      showLoader('Ouverture de ta personnalisation', { step: typeof step === 'number' ? step : 4 });
      go(editUrl(item), 200);
    }
    function actChange(step, item) {
      var s = stateForAction();
      s.replacing = { key: item.key, step: step, snapshot: s.seenKeys.slice() };
      s.pendingMode = 'change';
      s.armed = null;
      s.currentStep = step;
      s.changingStep = step;
      touch(s);
      showLoader('Choisis ton nouveau modèle', { step: step });
      go(URLS.compose + '#etape-' + (step + 1), 200);
    }
    function actExtra(step) {
      var s = stateForAction();
      s.replacing = null;
      s.pendingMode = 'extra';
      s.armed = null;
      s.currentStep = step;
      touch(s);
      showLoader('Choisis ton modèle en plus', { step: step });
      go(URLS.compose + '#etape-' + (step + 1), 200);
    }
    function actChoose(step) {
      var s = stateForAction();
      s.replacing = null; s.pendingMode = null; s.armed = null;
      s.currentStep = step;
      touch(s);
      showLoader('On y va', { step: step });
      go(URLS.compose + '#etape-' + (step + 1), 200);
    }
    function actRemove(item) {
      if (!window.confirm('Retirer « ' + item.product_title + ' » du panier ? Sa personnalisation sera perdue.')) return;
      removeLine(item.key).then(schedule);
    }
    function actSac(choice) {
      if (choice === 'yes') {
        var s = stateForAction();
        s.armed = { handle: SAC, step: null, mode: 'sac', at: now() };
        s.pendingMode = null;
        touch(s);
        showLoader('Ouverture du sac à dos', { step: 4 });
        go(URLS.sac, 200);
        return;
      }
      var st = read() || blank(false);
      st.sacChoice = choice;   /* 'no' ou null (changer d'avis) */
      write(st);
      schedule();
    }
    function actQuit() {
      exitPack();
      showLoader('Tu quittes le parcours', { sub: 'Ton panier est conservé.' });
      go(URLS.intro, 450);
    }
    function actRestart(an) {
      if (!window.confirm('Retirer tous les produits du pack de ton panier et recommencer ?')) return;
      showLoader('On repart de zéro');
      var keys = an.slots.reduce(function (a, ls) { return a.concat(ls); }, []).concat(an.sac).map(function (l) { return l.item.key; });
      keys.reduce(function (p, k) { return p.then(function () { return removeLine(k); }); }, Promise.resolve())
        .then(function () {
          var s = blank(true);
          write(s);
          go(URLS.compose + '#etape-1', 200);
        });
    }

    function lineHTML(l, step) {
      var img = (l.item.properties && l.item.properties._mczr_image) || l.item.image || '';
      return '<li class="ps-line">' +
        (img ? '<img class="ps-line__img" src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="ps-line__img"></span>') +
        '<div class="ps-line__body">' +
          '<div class="ps-line__title">' + esc(l.item.product_title) + '</div>' +
          '<div class="ps-line__qty">Quantité : ' + l.qty + '</div>' +
          '<div class="ps-line__actions">' +
            '<button type="button" class="ps-btn ps-btn--quiet ps-btn--small" data-a="edit" data-step="' + step + '" data-key="' + esc(l.item.key) + '">Modifier</button>' +
            (step === 'sac' ? '' : '<button type="button" class="ps-btn ps-btn--quiet ps-btn--small" data-a="change" data-step="' + step + '" data-key="' + esc(l.item.key) + '">Changer</button>') +
            '<button type="button" class="ps-link" data-a="remove" data-key="' + esc(l.item.key) + '">Retirer</button>' +
          '</div>' +
        '</div>' +
      '</li>';
    }

    function render() {
      busy = true;
      Promise.all([getCart(), loadCollections()]).then(function (r) {
        var cart = r[0], cols = r[1];
        var s = getActive();
        var p = s ? reconcileReplacement(s, cart, cols) : Promise.resolve(false);
        return p.then(function (removed) {
          if (removed) return Promise.all([getCart(), cols]);
          return [cart, cols];
        });
      }).then(function (r) {
        var cart = r[0], cols = r[1];
        lastCart = cart;
        var an = analyse(cart, cols);
        var s = getActive();
        if (s) { s.seenKeys = an.keys; touch(s); }
        var sacChoice = (read() || {}).sacChoice || null;
        paint(an, sacChoice);
      }).catch(function (e) {
        console.error('[PackSummer] récap :', e);
        mount.innerHTML = '<div class="ps-blank"><h2>Oups</h2><p>Impossible de charger ton panier.</p><a class="ps-btn ps-btn--primary" href="' + URLS.summary + '">Réessayer</a></div>';
      }).then(function () {
        busy = false;
        if (again) { again = false; render(); }
      });
    }

    function paint(an, sacChoice) {
      if (!an.hasPackLines) {
        mount.innerHTML =
          '<div class="ps-summary"><div class="ps-blank">' +
            '<h2>Ton pack est vide</h2>' +
            '<p>Compose ton Pack Summer en 4 étapes : un haut, un bas, un dessous et un accessoire.</p>' +
            '<button type="button" class="ps-btn ps-btn--primary" data-a="start">Composer mon pack</button>' +
          '</div></div>';
        mount.querySelector('[data-a="start"]').addEventListener('click', startPack);
        return;
      }

      var complete = an.packs > 0;
      var cards = STEPS.map(function (st, i) {
        var ls = an.slots[i];
        if (!ls.length) {
          return '<article class="ps-card ps-card--empty">' +
            '<div class="ps-card__head"><span class="ps-card__num">' + (i + 1) + '</span>' +
              '<div><div class="ps-card__kicker">' + esc(st.name) + ' · ' + esc(st.hint) + '</div>' +
              '<div class="ps-card__count">Pas encore choisi</div></div></div>' +
            '<div class="ps-empty-cta"><button type="button" class="ps-btn ps-btn--primary ps-btn--small" data-a="choose" data-step="' + i + '">' + esc(st.choose) + '</button></div>' +
          '</article>';
        }
        var total = an.qtyBy[i];
        var extra = complete ? total - an.packs : 0;
        var count = '<b>' + total + ' pièce' + (total > 1 ? 's' : '') + '</b>' +
          (extra > 0 ? ' · ' + an.packs + ' dans le pack, ' + extra + ' en plus' : '');
        return '<article class="ps-card">' +
          '<div class="ps-card__head"><span class="ps-card__num">' + CHECK + '</span>' +
            '<div><div class="ps-card__kicker">' + esc(st.name) + ' · ' + esc(st.hint) + '</div>' +
            '<div class="ps-card__count">' + count + '</div></div></div>' +
          '<ul class="ps-lines">' + ls.map(function (l) { return lineHTML(l, i); }).join('') + '</ul>' +
          '<div class="ps-card__foot"><button type="button" class="ps-link" data-a="extra" data-step="' + i + '">+ Ajouter un autre modèle</button></div>' +
        '</article>';
      }).join('');

      /* Récapitulatif chiffré */
      var rows = '';
      if (complete) {
        rows += '<div class="ps-row"><dt>' + an.packs + ' pack' + (an.packs > 1 ? 's' : '') + ' × ' + money(an.packUnit) + '</dt><dd>' + money(an.packTotal) + '</dd></div>';
      } else {
        rows += '<div class="ps-row"><dt>Articles du pack</dt><dd>' + money(an.grandTotal - an.sacTotal) + '</dd></div>';
      }
      if (complete && an.extras.length) {
        rows += '<div class="ps-row"><dt>Pièces en plus</dt><dd>' + money(an.extrasTotal) + '</dd></div>';
        an.extras.forEach(function (x) {
          rows += '<div class="ps-row ps-row--sub"><dt>' + x.qty + ' × ' + esc(x.title) + '</dt><dd>' + money(x.value) + '</dd></div>';
        });
      }
      if (an.sacQty > 0) {
        rows += '<div class="ps-row"><dt>Sac' + (an.sacQty > 1 ? 's' : '') + ' à dos (' + an.sacQty + ')</dt><dd>' + money(an.sacTotal) + '</dd></div>';
        if (complete && an.sacInPack > 0) {
          rows += '<div class="ps-row ps-row--sub"><dt>' + an.sacInPack + ' × ' + money(SAC_PACK_PRICE) + ' avec le pack' +
            (an.sacQty > an.sacInPack ? ', ' + (an.sacQty - an.sacInPack) + ' au prix normal' : '') + '</dt><dd></dd></div>';
        }
      }
      var saving = an.grandOrig - an.grandTotal;
      var tip = '';
      if (complete && an.packs < BULK_THRESHOLD) {
        var missing = BULK_THRESHOLD - an.packs;
        tip = '<div class="ps-tip">Encore ' + missing + ' pack' + (missing > 1 ? 's' : '') + ' et tu passes à ' + money(PACK_PRICE_BULK) + ' le pack.</div>';
      }
      var totalBox =
        '<div class="ps-total">' +
          '<div class="ps-total__title">Récapitulatif</div>' +
          '<dl style="margin:0">' + rows + '</dl>' +
          '<div class="ps-total__sum"><span>Total</span><strong>' + money(an.grandTotal) + '</strong></div>' +
          (saving > 99 ? '<div class="ps-total__orig">' + money(an.grandOrig) + '</div><div class="ps-save">Tu économises ' + money(saving) + '</div>' : '') +
          tip +
          (!complete ? '<p class="ps-note">Complète les 4 étapes pour obtenir le prix pack : ' + money(PACK_PRICE_SMALL) + ', puis ' + money(PACK_PRICE_BULK) + ' dès ' + BULK_THRESHOLD + ' packs.</p>' : '') +
        '</div>';

      /* Sac à dos : une question, jamais une redirection imposée */
      var sacImg = mount.getAttribute('data-sac-image') || '';
      var sacBox = '';
      if (an.sacQty > 0) {
        sacBox = '<div class="ps-sac"><ul class="ps-lines" style="margin:0">' +
          an.sac.map(function (l) { return lineHTML(l, 'sac'); }).join('') + '</ul></div>';
      } else if (complete && sacChoice === 'no') {
        sacBox = '<div class="ps-sac ps-sac--no"><span>Sans sac à dos</span><button type="button" class="ps-link" data-a="sac-undo">Finalement, j\'en veux un</button></div>';
      } else if (complete) {
        sacBox =
          '<div class="ps-sac ps-sac--ask"><div class="ps-sac__row">' +
            (sacImg ? '<img class="ps-sac__img" src="' + esc(sacImg) + '" alt="Sac à dos personnalisé" loading="lazy">' : '') +
            '<div><div class="ps-sac__title">Un sac à dos avec ton pack ?</div>' +
            '<div class="ps-sac__text">' + money(SAC_PACK_PRICE) + ' le sac personnalisé au lieu de 35 €, un par pack. Pour tes loooonnngs week-ends !</div></div>' +
          '</div>' +
          '<div class="ps-sac__actions">' +
            '<button type="button" class="ps-btn ps-btn--primary ps-btn--small" data-a="sac-yes">Oui, je le personnalise</button>' +
            '<button type="button" class="ps-btn ps-btn--quiet ps-btn--small" data-a="sac-no">Non merci</button>' +
          '</div></div>';
      }

      var doneCount = an.filled.filter(Boolean).length;
      var notice = '';
      if (!complete) {
        var firstEmpty = an.filled.indexOf(false);
        notice = '<div class="ps-notice">Ton pack n\'est pas encore complet (' + doneCount + '/4). Il te manque : ' +
          an.filled.map(function (f, i) { return f ? null : STEPS[i].hint.toLowerCase(); }).filter(Boolean).join(', ') + '.</div>';
      }

      mount.innerHTML =
        '<div class="ps-summary ps-reveal">' +
          '<div class="ps-summary__stepper">' + stepperHTML(4, an.filled, { recap: true, links: true }) + '</div>' +
          notice +
          '<div class="ps-grid">' +
            '<section class="ps-steps" aria-label="Les 4 étapes de ton pack">' + cards + '</section>' +
            '<aside class="ps-side">' + totalBox + sacBox +
              (complete
                ? '<a class="ps-btn ps-btn--primary ps-cta" href="' + URLS.checkout + '">Valider et payer · ' + money(an.grandTotal) + '</a>'
                : '<button type="button" class="ps-btn ps-btn--primary ps-cta" data-a="choose" data-step="' + an.filled.indexOf(false) + '">Compléter mon pack</button>') +
              '<div class="ps-foot">' +
                '<button type="button" class="ps-link" data-a="quit">Quitter le pack</button>' +
                '<button type="button" class="ps-link" data-a="restart">Tout recommencer</button>' +
              '</div>' +
            '</aside>' +
          '</div>' +
        '</div>';

      var byKey = {};
      (lastCart.items || []).forEach(function (it) { byKey[it.key] = it; });
      mount.querySelectorAll('[data-ps-step]').forEach(function (el) {
        el.addEventListener('click', function () {
          var v = el.getAttribute('data-ps-step');
          if (v === 'recap') return;
          var i = parseInt(v, 10);
          if (an.slots[i].length) {
            var card = mount.querySelectorAll('.ps-card')[i];
            if (card) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else actChoose(i);
        });
      });
      mount.querySelectorAll('[data-a]').forEach(function (el) {
        el.addEventListener('click', function () {
          var a = el.getAttribute('data-a');
          var stepAttr = el.getAttribute('data-step');
          var step = stepAttr === 'sac' ? 'sac' : parseInt(stepAttr, 10);
          var item = byKey[el.getAttribute('data-key')];
          if (a === 'edit' && item) actEdit(step, item);
          else if (a === 'change' && item) actChange(step, item);
          else if (a === 'remove' && item) actRemove(item);
          else if (a === 'extra') actExtra(step);
          else if (a === 'choose') actChoose(step);
          else if (a === 'sac-yes') actSac('yes');
          else if (a === 'sac-no') actSac('no');
          else if (a === 'sac-undo') actSac(null);
          else if (a === 'quit') actQuit();
          else if (a === 'restart') actRestart(an);
          else if (a === 'start') startPack();
        });
      });
    }

    render();
  }

  /* ======================================================================
     Export
     ====================================================================== */
  /* Armement abandonné : le client a cliqué « Modifier » ou une carte, puis est
     parti ailleurs sans ajouter. Sans ce nettoyage, ajouter plus tard ce même
     produit en dehors du parcours supprimait une ligne du pack (remplacement)
     ou redirigeait vers le parcours. L'armement ne survit que sur la fiche du
     produit armé et sur le panier (où Kickflip renvoie après l'ajout). */
  (function dropStaleArming() {
    if (isEditor) return;
    var s = read();
    if (!s || (!s.armed && !s.pendingMode && !s.replacing && !s.replacingKey)) return;
    var path = location.pathname.replace(/\/$/, '');
    var onCart = /\/cart$/.test(path);
    var pm = path.match(/\/products\/([^/?#]+)/);
    var onArmedProduct = !!(pm && s.armed && decodeURIComponent(pm[1]) === s.armed.handle);
    var onCompose = path === URLS.compose;
    if (onArmedProduct) {
      /* Le module ne tourne pas sur toutes les pages (accueil, collections) :
         on exige donc d'arriver sur la fiche JUSTE après le clic qui arme.
         Rechargement et retour arrière restent admis ; une nouvelle visite, non. */
      var nav = '';
      try { nav = (performance.getEntriesByType('navigation')[0] || {}).type || ''; } catch (e) {}
      if (!s.armed.landedAt && now() - (s.armed.at || 0) <= 90 * 1000) { s.armed.landedAt = now(); write(s); return; }
      if (s.armed.landedAt && (nav === 'reload' || nav === 'back_forward')) return;
    }
    if (onCart && s.armed && s.armed.landedAt) return;
    if (onCart && !s.armed) return;
    var changed = false;
    if (s.armed) { s.armed = null; changed = true; }
    if (!onCompose && (s.pendingMode || s.replacing || s.replacingKey)) {
      s.pendingMode = null; s.replacing = null;
      s.replacingKey = null; s.replacingStep = null; s.replacingSnapshot = null;
      s.editingStep = null; s.changingStep = null; s.upsellStep = false;
      changed = true;
    }
    if (changed) write(s);
  })();

  /* Arrivé sur la page visée : la décision est honorée, on l'efface. */
  (function () {
    var s = read();
    if (s && s.redirectTo && s.redirectTo.url && location.pathname === s.redirectTo.url.split('#')[0]) {
      s.redirectTo = null; write(s);
    }
  })();

  window.PackSummer = {
    __v: 3,
    initIntro: initIntro,
    initCompose: initCompose,
    initProduct: initProduct,
    initCartRouter: initCartRouter,
    initSummary: initSummary,
    startPack: startPack,
    exitPack: exitPack,
    showLoader: showLoader,
    hideLoader: hideLoader,
    /* compatibilité avec d'anciens appels */
    showTransition: function (msg, badge) { showLoader(msg, { sub: badge }); },
    /* exposés pour les tests */
    _analyse: analyse,
    _lineQty: lineQty,
    lineId: lineId,
    changeById: changeById,
    enrichCart: enrichCart,
    _stepperHTML: stepperHTML,
    _reconcile: reconcileReplacement
  };
})();
